
import AppData from './../../../Model/AppData';
import OrderHandler from './OrderHandler';
import { TableSessionType } from '../../Common/Enum/TableSessionType';

let _instance = null

export const WorkingHourType = {
    DINE_IN : 1,
    PICKUP  : 2,
    DELIVERY: 3,
}
export default class WorkingHourHandler {
    static getInstance = () => {
        if (!_instance) {
            _instance = new WorkingHourHandler()
        }
        return _instance
    }
    static isWithinWorkingHour = () => {
        if (!_instance) {
            _instance = new WorkingHourHandler()
        }
        return !_instance.isBusinessClosed()
    }

    static getTodayWorkingHourAsString = () => {
        let { start, end } = _instance.getBusinessOpenAndCloseTime()
        if (!start || !end) {
            return ""
        }
        return `Operating hour is ${start.format('hh:mm a')} - ${end.format("hh:mm a")}`
    }

    getDefaultWorkingHours = () => {
        return {
            start_time  : "12:00:00",
            end_time    : "18:00:00",
        }
    }
    getTodayWorkingHour = () => {
        const merchant = AppData.data.state.merchant
        const publicHolidays = AppData.data.state.publicHoliday
        let defaultWorkingHour = [this.getDefaultWorkingHours()]
        if (!merchant) {
            return defaultWorkingHour
        }
        let today = moment()
        let isTodayPublicHoliday = publicHolidays && Array.isArray(publicHolidays) ? publicHolidays.find( holiday => moment(holiday.ph_date).isSame( today, 'day' ) ) : null
        const workingHour = (merchant.working_hours || []).filter( workingHour => {
            return isTodayPublicHoliday ? 
                workingHour.day == 'PH' : 
                workingHour.day == today.format('ddd')
        } )
        return workingHour.length ? workingHour : defaultWorkingHour
    }
    getBusinessOpenAndCloseTime = () => {
        let workingHour = this.getTodayWorkingHour()
        let start = []
        let end = []
        if(Array.isArray(workingHour)) {
            workingHour.map(
                (workingHour) => {
                    start.push(moment(workingHour.start_time, "hh:mm:ss"))
                    end.push(moment(workingHour.end_time, "hh:mm:ss"))
                }
            )
        } else {
            if (workingHour && Array.isArray(workingHour)) {
                workingHour = workingHour[0]
            }
            start = moment(workingHour.start_time, "hh:mm:ss")
            end = moment(workingHour.end_time, "hh:mm:ss")
        }
        return {start, end}
    }
    isBusinessClosed = () => {
        let { start, end } = this.getBusinessOpenAndCloseTime()
        let isBusinessClosed = true
        let isBusinessClosedTotal = null
        if (Array.isArray(start)) {
            // Loop the working hour list to find if current time is within any of the
            // slot. If a matching slot is found, end loop.
            for (let i = 0; i < start.length; i++) {
                if (moment().isBetween(start[i], end[i], 'minute', "[]")) {
                    isBusinessClosed = false
                    break    
                }
            }
        }
        else {
            if (start && Array.isArray(start)) {
                start = start[0]
            }
            if (end && Array.isArray(end)) {
                end = end[0]
            }
            isBusinessClosed = !moment().isBetween(start, end, 'minute', "[]")
        }
        return isBusinessClosed
    }
}